import { render } from "./VisitSpecimenCollectionStats.vue?vue&type=template&id=8f246b96"
import script from "./VisitSpecimenCollectionStats.vue?vue&type=script&lang=js"
export * from "./VisitSpecimenCollectionStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__